var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.articles ? _c('section', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('section', {
    staticClass: "col-md-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, _vm._l(_vm.articles, function (category, i) {
    return _c('li', {
      key: i,
      staticClass: "nav-item",
      class: {
        'active': i === 0
      }
    }, [_c('a', {
      staticClass: "nav-link",
      attrs: {
        "id": ("tab-" + (category.id)),
        "data-toggle": "tab",
        "href": ("#tabContent-" + (category.id)),
        "role": "tab",
        "aria-controls": "profile",
        "aria-selected": "true"
      }
    }, [_vm._v(_vm._s(category.name) + " ")])]);
  }), 0), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, _vm._l(_vm.articles, function (category, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-pane fade show",
      class: {
        'active': i === 0
      },
      attrs: {
        "id": ("tabContent-" + (category.id)),
        "role": "tabpanel",
        "aria-labelledby": "profile-tab"
      }
    }, [category.articles.length > 0 ? _c('carousel', {
      key: i,
      staticClass: "pg support-carousel",
      attrs: {
        "autoplay": true,
        "margin": 20,
        "responsive": {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3,
            nav: true,
            dots: false
          }
        }
      }
    }, [_vm._l(category.articles, function (article, j) {
      return _c('div', {
        key: j,
        staticClass: "card"
      }, [_c('div', {
        staticClass: "position-relative"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: _vm.makeImage(article.image),
          expression: "makeImage(article.image)"
        }],
        staticClass: "card-img-top",
        attrs: {
          "alt": article.title
        }
      }), _c('img', {
        staticClass: "imgIcon",
        attrs: {
          "src": ((_vm.assetsUrl()) + "/images/cycleIcon.png")
        }
      })]), _c('div', {
        staticClass: "card-body cardContent"
      }, [_c('h4', {
        staticClass: "card-title cardHeading"
      }, [_vm._v(_vm._s(article.title))]), _c('p', {
        staticClass: "card-text",
        domProps: {
          "innerHTML": _vm._s(article.content)
        }
      }), _c('router-link', {
        attrs: {
          "to": {
            name: 'article',
            params: {
              slug: article.slug
            }
          }
        }
      }, [_vm._v("LEARN MORE")])], 1)]);
    }), _c('template', {
      slot: "prev"
    }, [_c('button', {
      staticClass: "owl-prev",
      attrs: {
        "role": "presentation",
        "type": "button"
      }
    }, [_c('span', {
      attrs: {
        "aria-label": "Previous"
      }
    }, [_vm._v("‹")])])]), _c('template', {
      slot: "next"
    }, [_c('button', {
      staticClass: "owl-next",
      attrs: {
        "role": "presentation",
        "type": "button"
      }
    }, [_c('span', {
      attrs: {
        "aria-label": "Next"
      }
    }, [_vm._v("›")])])])], 2) : _c('p', {
      staticClass: "text-warning p-3"
    }, [_vm._v("There are no articles for this category")])], 1);
  }), 0)])])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }